import { featureFlags, isFeatureEnabled } from '@/config/featureFlags';

const domainFlagById = {
  operate: 'optionCOperateV2',
  manage: 'optionCManageV2',
  analyze: 'optionCAnalyzeV2',
  admin: 'optionCAdminV2',
  tools: 'optionCToolsV2',
};

export function useFeatureFlags() {
  const hasFlag = (flagName) => Object.prototype.hasOwnProperty.call(featureFlags, flagName);
  const getFlag = (flagName, fallback = false) => (hasFlag(flagName) ? isFeatureEnabled(flagName) : fallback);
  const isRouteEnabled = (routeMeta = {}) => (routeMeta.featureFlag ? getFlag(routeMeta.featureFlag, false) : true);
  const isDomainEnabled = (domainId) => {
    const flagName = domainFlagById[domainId];
    return flagName ? getFlag(flagName, false) : false;
  };

  return {
    flags: featureFlags,
    isEnabled: isFeatureEnabled,
    hasFlag,
    getFlag,
    isRouteEnabled,
    isDomainEnabled,
    domainFlagById,
  };
}
